const MemberResource = function ($resource, ApiRequestParams, AppConfig) {
    return $resource(
        AppConfig.apiBaseUrl + 'members/',
        ApiRequestParams.defaults(),
        {
            update: {
                method: 'PUT',
                url: AppConfig.apiBaseUrl + 'members/:memberID'
            }
        }
    );
};

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = MemberResource;
}
